"use client";

import type {TextFieldProps as RACTextFieldProps} from "react-aria-components";
import {TextField as RACTextField} from "react-aria-components";
import clsMerge from "../../util/clsMerge";
import Label, {LabelClasses} from "./Label";
import FormHelperText, {HelperTextClasses} from "./FormHelperText";
import {ForwardedRef, forwardRef} from "react";

export type TextFieldClasses = {
	root?: string;
	label?: LabelClasses;
	helperText?: HelperTextClasses;
};

export type TextFieldProps = {
	classes?: TextFieldClasses;
	helperText?: string;
	hideErrors?: boolean;
	hideLabelDecorators?: boolean;
	labelText: string;
	hideLabel?: boolean;
	children?: React.ReactNode;
} & RACTextFieldProps;

// https://react-spectrum.adobe.com/react-aria/TextField.html
const TextField = (
	props: TextFieldProps,
	ref: ForwardedRef<HTMLDivElement>
) => {
	const {
		classes,
		children,
		helperText,
		hideErrors,
		hideLabelDecorators,
		labelText,
		hideLabel,
		...textFieldProps
	} = props;
	return (
		<RACTextField
			className={clsMerge("flex flex-col gap-1", classes?.root)}
			ref={ref}
			aria-label={labelText}
			{...textFieldProps}
		>
			{({isDisabled}) => {
				return (
					<>
						{!hideLabel && (
							<Label
								classes={classes?.label}
								isDisabled={isDisabled}
								isRequired={props.isRequired}
								hideDecorators={hideLabelDecorators}
							>
								{labelText}
							</Label>
						)}
						{children}
						<FormHelperText
							helperText={helperText}
							classes={classes?.helperText}
							hideErrors={hideErrors}
						/>
					</>
				);
			}}
		</RACTextField>
	);
};

export default forwardRef<HTMLDivElement, TextFieldProps>(TextField);
